module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-搜索-搜索框内置.5f2c2.png";